import React from "react"

function IconStatusBusy({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="status-busy"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-status-busy"
      {...props}
    >
      <path
        d="M21.849 12.125c0 5.49-4.452 9.942-9.943 9.942-5.493 0-9.942-4.451-9.942-9.942a9.94 9.94 0 0 1 9.942-9.943c5.491 0 9.943 4.45 9.943 9.943"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__danger"
      />
      <path
        d="M6.678 13.581h10.395a1.425 1.425 0 0 0 0-2.85H6.678a1.425 1.425 0 1 0 0 2.85z"
        fill={color2 || color}
        fillRule="nonzero"
      />
    </svg>
  )
}

export default IconStatusBusy
